import { render, staticRenderFns } from "./Premium.vue?vue&type=template&id=c0e9728a"
import script from "./Premium.vue?vue&type=script&lang=js"
export * from "./Premium.vue?vue&type=script&lang=js"
import style0 from "./Premium.vue?vue&type=style&index=0&id=c0e9728a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports